import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { postAxios, getAxios } from '../../axios/Axios';
import request from '../../request/request';
import Config from '../../config/Config';
import { ToastTypes } from '../constants/Constants';

function Login({ setLogin, setUser, changeToast }) {
  const [loginLoading, setLoginLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const submitLoginForm = async (e) => {
    e.preventDefault();
    setLoginLoading(true);

    const email = document.getElementById("usernameInput").value;
    const password = document.getElementById("passwordInput").value;

    if (!email) {
      setEmailError("Username is required");
      setLoginLoading(false);
      return;
    } else {
      setEmailError("");
    }

    if (!password) {
      setPasswordError("Password is required");
      setLoginLoading(false);
      return;
    } else {
      setPasswordError("");
    }

    const data = {
      username: email,
      password: password
    };

    try {
      const res = await postAxios(request.loginForm, data);
      if (res.data.apiresponse.type === "OK") {
        const whoamiRes = await getAxios(request.whoami);
        if (whoamiRes.data.apiresponse.code === 'LOGGEDIN') {
          const privileges = whoamiRes?.data?.privileges || {};
          const hasDashboardAccess = privileges.BABUSIYA_DASHBOARD_ACCESS === 1;
          
          if (hasDashboardAccess) {
            setUser({
              fullname: whoamiRes?.data?.person?.fullname,
              profilePic: whoamiRes?.data?.profile_pic,
              partyId: whoamiRes?.data?.person?.party_id,
              privileges,
            });
            setLogin(false);
            changeToast(ToastTypes.TOAST_SUCCESS, ToastTypes.TOAST_SUCCESS_TITLE, "Login Successful");
          } else {
            changeToast(ToastTypes.TOAST_ERROR, ToastTypes.TOAST_ERROR_TITLE, "Access Denied: You don't have permission to access the dashboard");
          }
        } else {
          changeToast(ToastTypes.TOAST_ERROR, ToastTypes.TOAST_ERROR_TITLE, "Authentication verification failed");
        }
      } else {
        changeToast(ToastTypes.TOAST_ERROR, ToastTypes.TOAST_ERROR_TITLE, "Incorrect Password");
      }
    } catch (error) {
      console.error('Login Error:', error);
      changeToast(ToastTypes.TOAST_ERROR, ToastTypes.TOAST_ERROR_TITLE, "Login Failed");
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <section className="login-container">
        <div className="row h-100 g-0">
          {/* Left side - Background Image */}
          <div className="col-md-8 login-left-section">
            <div className="login-bg-overlay">
              <h1 className="login-left-title">Babbusiya Management System</h1>
            </div>
          </div>
          
          {/* Right side - Login Form */}
          <div className="col-md-4 login-right-section">
            <div className="login-form-wrapper">
              {/* Logo */}
              <div className="login-logo-container">
                <img src={Config.babusiyaLogo} alt="Babusiya Logo" className="login-logo" />
              </div>
              
              {/* Form */}
              <div className="login-form-content">
                <h2 className="login-title">Sign In</h2>
                <p className="login-subtitle">
                  Don't have an account yet? <br /> Please contact Babbusiya team
                </p>
                
                <form onSubmit={submitLoginForm}>
                  <div className="form-group mb-4">
                    <label className="login-label" htmlFor="usernameInput">Username</label>
                    <input 
                      type="text" 
                      id="usernameInput" 
                      className="form-control login-input" 
                      placeholder="iwc_admin"
                    />
                    {emailError && <p className="text-danger mt-1 mb-0" style={{ fontSize: '0.875rem' }}>{emailError}</p>}
                  </div>

                  <div className="form-group mb-4">
                    <label className="login-label" htmlFor="passwordInput">Password</label>
                    <div className="password-input-wrapper">
                      <input 
                        type={showPassword ? "text" : "password"} 
                        id="passwordInput" 
                        className="form-control login-input" 
                        placeholder="••••••"
                      />
                      <i 
                        className={`password-toggle-icon fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                        onClick={() => setShowPassword(!showPassword)}
                      ></i>
                    </div>
                    {passwordError && <p className="text-danger mt-1 mb-0" style={{ fontSize: '0.875rem' }}>{passwordError}</p>}
                  </div>
                  <Button
                    disabled={loginLoading}
                    type="submit" 
                    className="w-100 signin-button"
                  >
                    {loginLoading ? "Signing In..." : "Sign In"}
                  </Button>
                </form>
                
                {/* Footer */}
                <div className="login-footer">
                  <p className="mb-0">© {new Date().getFullYear()} RedGrape Technologies Private Limited.</p>
                  <p>Designed & Developed By RedGrape Technologies.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
}

export default Login;
